import React from 'react';

const QuickSight = () => {
  return (
    <div>
      <iframe
        width="100%"
        height="720"
        src="https://us-east-1.quicksight.aws.amazon.com/sn/embed/share/accounts/346781725075/dashboards/7792d0cd-40ce-45ad-b984-94882b8a2f5c?directory_alias=nex-crossing">
      </iframe>
    </div>
  );
};

export default QuickSight;
